import { FC } from "react";

interface IProps {
  prefixText: string;
  suffixText: string;
  value: string;
  onChange: (event: any) => void;
  disabled: boolean;
}

const InputBox: FC<IProps> = ({
  prefixText, suffixText, value, onChange, disabled
}) => {
  return (
    <div className="flex flex-justify-center my-1">
      <div className="v-line">{prefixText}</div>
      <input
        type="text"
        className="form-control mx-1 w-100p"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="v-line">{suffixText}</div>
    </div>
  );
}

export default InputBox;
